import {CommonService} from "./common/commonService";
import { ServicesConfig } from "./servicesConfig";

export class MapService {

    static getVersion = () => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/sgvmap/version/")
    )

 
    static getMap = (mapId) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/sgvmap/map/" + mapId)
    )

    static getMaps = () => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/sgvmap/maps")
    )
}